export default __webpack_public_path__ + "static/media/1062.8040bb6b.png";